export default {
    add: {
        index: {
            okTitle: 'Add',
            cancelTitle: 'Cancel',
            title: 'Adding a product',
        },

        quantity: 'Quantity',

        search: {
            description: 'Enter the local product code or barcode.',
            label: 'Code',
        },

        searchList: {
            text1: 'LK',
            text2: 'SK',
            text3: 'Price',
        },
    },

    list: {
        emptyText: 'No products found',
        emptyFilteredText: 'No products found',
        action: '[ACTION]',
        tooltip: 'Copy all local product codes',
        validate:
      'The quantity cannot be less than zero | The number of collected goods cannot exceed the number of ordered',
        tarePlaceholder: 'Specify the number of packed items',
    },

    productComment: {
        label1: 'Reason for the change:',
        label2: 'Comment:',
    },
};